'use strict';

var _ = require('lodash');
var SearchCriteriaValidationService = function SearchCriteriaValidationService() {
  function isLeftDateOperandGreaterThenRight(newObj, oldObj) {
    return !_.isUndefined(newObj.leftOperand) && !newObj.leftOperand.isSame(oldObj.leftOperand) && newObj.leftOperand.isAfter(newObj.rightOperand);
  }
  function isRightDateOperandLesserThenLeft(newObj, oldObj) {
    return !_.isUndefined(newObj.rightOperand) && !newObj.rightOperand.isSame(oldObj.rightOperand) && newObj.rightOperand.isBefore(newObj.leftOperand);
  }
  var update2datetimePickerValues = function update2datetimePickerValues(newObj, oldObj) {
    if (isLeftDateOperandGreaterThenRight(newObj, oldObj)) {
      newObj.rightOperand = newObj.leftOperand;
    }
    if (isRightDateOperandLesserThenLeft(newObj, oldObj)) {
      newObj.leftOperand = newObj.rightOperand;
    }
  };
  return {
    update2datetimePickerValues: update2datetimePickerValues
  };
};
SearchCriteriaValidationService.$inject = [];
module.exports = SearchCriteriaValidationService;